import moment from "moment";
import Holiday from "../models/Holiday";

export default class HolidayUtils {
  /**
   * Given a date and a list of holidays, it checks if the past date is included in the list of holidays.
   * @param date
   * @param holidays
   * @returns True if it is included. False if it isn't.
   */
  public static isHoliday(date: Date, holidays: Holiday[]): boolean {
    return !!holidays.find((holiday) => {
      const holidayDate = new Date(holiday.shortDate);
      return moment(date).isSame(holidayDate, "day");
    });
  }
}
